import { render, staticRenderFns } from "./NavbarCategory.vue?vue&type=template&id=4223f3fe&"
import script from "./NavbarCategory.vue?vue&type=script&lang=js&"
export * from "./NavbarCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports